// NotificationsTab.tsx - Uses AdminNotificationsPage component
import React from 'react';
import AdminNotificationsPage from '../../pages/AdminNotificationsPage';

const NotificationsTab: React.FC = () => {
  return <AdminNotificationsPage />;
};

export default NotificationsTab;
